<template>
	<div>
		<div>
			<div class="view-framework">
				<userLeft></userLeft>
				<div class="view-framework-body">
					<div class="view-framework-main">
						<notic :noticle="noticle" :noticleList="noticleList"></notic>
						<div class="box">
							<div class="usercenter clearfix">
								<div class="usercenter-info">
									<img class="avatar" width="60" height="60" :src="userList.avatarUrl?userList.avatarUrl:'../../static/images/logo.png'"/>
									<!-- <h5>亲爱的{{userList.nickName}}</h5> -->
									<p>
										欢迎回到{{$namePc}}账户中心
										<span class="sep">|</span>
										<a href="javascript:;" @click="$commonJs.getOut" class="text-light" >退出</a>
									</p>
									<div class="user-security">
										<label>用户ID：</label>
										<span>{{userList.user_id}}</span>
									</div>
								</div>
								<div class="usercenter-assets">
									<div class="assets-icon">
										<i class="iconfont icon-jinqian text-orange"></i>
									</div>
									<div class="assets-title">
										<span class="text-gray">账户余额（元）：</span>
									</div>
									<div class="assets-money">{{userList.balance}}</div>
								</div>
								<div class="usercenter-cash">
									<p>
										<router-link class="btn btn-primary" :to="{path:'/withdraw'}">提现</router-link>
										<router-link class="btn btn-link" :to="{path:'/withdrawList'}">提现记录</router-link>
									</p>
								</div>
							</div>
							<ul class="security-group clearfix">
								<li class="security-item">
									<div class="security-item-bg " :class="{'security-item-finish':userList.is_real === 1}">
										<div class="security-item-icon">
											<i class="iconfont icon-shimingrenzheng1"></i>
										</div>
										<h5>{{userList.is_real === 0 && userList.is_advanced===0?"实名认证后才可以提现":userList.is_real===1&&userList.is_advanced===0?"已完成初级实名请完成高级实名":userList.is_real === 1&&userList.is_advanced===1?"已完成所有实名":"请先完成实名"}}</h5>
									</div>
									<div class="security-item-action">
										<a class="btn" :class="userList.is_real === 0 && userList.is_advanced===0?'btn-primary':userList.is_real===1&&userList.is_advanced===0?'btn-primary':userList.is_real === 1&&userList.is_advanced===1?'btn-green':'btn-green'" @click="real()"  >
											<i class="iconfont icon-shimingrenzheng1"></i>
											{{userList.is_real === 0 && userList.is_advanced===0?"实名认证":userList.is_real===1&&userList.is_advanced===0?"已初级实名":userList.is_real === 1&&userList.is_advanced===1?"已完成实名":"实名认证"}}
										</a>
									</div>
								</li>
								<li class="security-item">
									<div class="security-item-bg " :class="{'security-item-mobile':userList.phone}">
										<div class="security-item-icon">
											<i class="iconfont icon-shouji"></i>
										</div>
										<h5>{{userList.phone?$fxLink.checkHide(userList.phone):"请先绑定手机号"}}</h5>
									</div>
									<div class="security-item-action">
										<a class="btn" :class="userList.phone?' btn-green':'btn-primary'" @click="openPhone">
											<i class="iconfont icon-shimingrenzheng1"></i>
											{{userList.phone?"更换手机":"绑定手机"}}
										</a>
									</div>
								</li>
								<li class="security-item">
									<div class="security-item-bg security-item-password">
										<div class="security-item-icon">
											<i class="iconfont icon-mima"></i>

										</div>
										<h5>建议常修改密码</h5>
									</div>
									<div class="security-item-action">
										<router-link :to="{path:'/passWord'}" class="btn btn-green">
											<i class="iconfont icon-mima"></i>
											修改密码
										</router-link>
									</div>
								</li>
								<li>
									<div class="security-item-bg security-item-weixin">
										<img width="172" :src="settingPc && settingPc.wxmp_img?settingPc.wxmp_img.file_path:''"/>
									</div>
									<div class="security-item-action">
										<p>
											扫码关注微信公众号
											<br>
											你的卖卡信息每一步
											<br>
											都会通过微信提醒您
										</p>
									</div>
								</li>
							</ul>
						</div>
						<div class="box usercenter-sellrecords">
							<h3 class="box-caption">热门回收推荐给您：</h3>
							<div class="cards-group owl-carousel owl-theme" >
								<div class="owl-wrapper">
									<div class="owl-item" style="width: 184px;margin-top: 10px;" v-for="(item,inedx) in hotList">
										<div class="item">
											<div class="cards-cover">
												<router-link :to="{path:'/shop?cateid='+item.cate_id+'&goodid='+item.id}">
													<img  :src="item.image?item.image.file_path:''"/>
												</router-link>
												<h5 class="title">{{item.goods_name}}</h5>
												<div class="actions">
													<router-link class="btn btn-default" :to="{path:'/shop?cateid='+item.cate_id+'&goodid='+item.id}">我有卡要回收</router-link>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import notic from '../common/noticle/index.vue'
	export default{
		data(){
			return{
				noticle:"",
				userList:[],
				hotList:[],
        noticleList:{},
        settingPc:{}
			}
		},
		components:{
			notic,
		},
		created(){
      this.settingPc = JSON.parse(localStorage.getItem('settingPc'))
      this.getAllNotcile()
			this.getNotcile()
			this.getUserList()
			this.hot()

		},
		methods:{
      getAllNotcile(){
      	let token = localStorage.getItem('token')
      	this.$api.noticepc({
      		token:token,
          page:1
      	}).then(res => {
          // console.log(res)
      		if(res.code === 1){
            if(res.data.data.length > 0){
              this.noticleList = res.data.data[0]
            }
      		}
      	})
      },
			real(){
				this.$router.push({ path:'/real'})
			},
			openPhone(){
				if(this.userList.phone){
					this.$router.push({ path:'/updatePhone'})
				}else{
					this.$router.push({ path:'/bindPhone'})
				}
			},
			getNotcile(){
				let token = localStorage.getItem('token')
				this.$api.getIndexNotice({
					token:token
				}).then(res => {
					if(res.code === 1){
						this.noticle = res.data.notice
					}
				})
			},
			hot() {
				let token = localStorage.getItem('token')
					this.$api.apiAddress({
							token:token
					}).then(res => {
							if(res.code === 1){
								this.hotList = res.data
							}
					})
			},
			getUserList(){
				let token = localStorage.getItem('token')
				this.$api.userInfo({
					token
				}).then(result => {
					if(result.code === 1){
						localStorage.setItem("userInfo",JSON.stringify(result.data))
						this.userList = result.data
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/user/user.vue